import React from 'react'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import './Laserhair.css'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceFAQ from '../ServiceFAQ'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const laserFAQs = [
  {
    question: 'How many sessions of laser hair reduction are needed?',
    answer: 'Most people need 6 to 8 sessions spaced 4 to 6 weeks apart for a significant, long-lasting reduction in hair growth.',
  },
  {
    question: 'Is laser hair removal painful?',
    answer: "Most people describe it as a mild snapping sensation, similar to a rubber band flick. It's generally well tolerated.",
  },
  {
    question: 'Is it safe for all skin tones?',
    answer: 'Yes, with the right laser technology and settings adjusted for your skin tone, the treatment can be done safely on most skin types.',
  },
  {
    question: 'Are results permanent?',
    answer:
      "It's best described as long-term hair reduction rather than 100% permanent removal, since some fine hairs can regrow due to hormonal changes.",
  },
]

const Laserhair = () => {
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='laserhairhero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Laser hair reduction
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Best Laser Hair Removal Treatment in Pitampura | Permanent Hair Reduction Clinic
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for the best laser hair removal treatment in Pitampura? Get safe and advanced laser technology for long-term hair reduction .
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>

        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Best Laser Hair Removal Treatment in Pitampura</h2>
              <p>
                Unwanted body hair is a common concern for both men and women. Traditional methods such as shaving, waxing, and threading often
                provide only temporary results and may cause irritation, ingrown hair, or skin darkening. Modern aesthetic technology offers a more
                effective solution through laser hair removal.
              </p>
              <p>
                If you are searching for the <span style={{ fontWeight: 'bold' }}>best laser hair removal treatment in Pitampura</span>, advanced
                cosmetic clinics provide safe and precise laser procedures designed to reduce unwanted hair and improve overall skin smoothness.
              </p>
              <p>
                Laser hair removal is a popular non-surgical treatment that offers long-term hair reduction and smoother skin with minimal discomfort.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>What is Laser Hair Removal?</h3>
              <p>
                Laser hair removal is a cosmetic procedure that uses concentrated light energy to target the pigment in hair follicles. The laser
                energy converts into heat, which damages the hair follicle and slows down future hair growth.
              </p>
              <p>
                Because hair grows in cycles, multiple sessions are usually required to effectively target the follicles during their growth phase.
              </p>
              <p>With repeated treatments, hair growth becomes thinner, lighter, and less noticeable.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Benefits of Laser Hair Removal</h3>
              <p>
                Choosing the <span style={{ fontWeight: 'bold' }}>best laser hair removal treatment in Pitampura</span> provides several advantages:
              </p>
              <ul>
                <li>Long-term reduction in unwanted hair</li>
                <li>Smoother and clearer skin</li>
                <li>Reduced ingrown hair and razor bumps</li>
                <li>Precise treatment that protects surrounding skin</li>
                <li>Faster treatment sessions compared to traditional hair removal methods</li>
              </ul>
              <p>Laser treatment can be performed on many body areas, including the face, underarms, legs, bikini line, and back.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Areas Commonly Treated with Laser Hair Removal</h3>
              <p>Laser hair removal can safely target unwanted hair on different parts of the body, such as:</p>
              <ul>
                <li>Upper lip and chin</li>
                <li>Underarms</li>
                <li>Arms and legs</li>
                <li>Bikini area</li>
                <li>Chest and back</li>
                <li>Full body hair reduction</li>
              </ul>
              <p>
                Small areas like the upper lip can take only a few minutes to treat, while larger areas may take longer depending on the size of the
                treatment zone.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Laser Hair Removal Procedure</h3>
              <p>The procedure is simple and usually completed in a short time.</p>

              <p>
                <span style={{ fontWeight: 'bold' }}>1. Consultation and Skin Assessment</span>
                <br />A specialist evaluates your skin type, hair texture, and treatment area.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>2. Preparation</span>
                <br />
                The treatment area is cleaned and protective eyewear is provided during the procedure.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>3. Laser Treatment</span>
                <br />A handheld laser device delivers controlled pulses of light to the hair follicles.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>4. Post-Treatment Care</span>
                <br />
                Patients may experience mild redness or swelling for a few hours, which usually settles quickly.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>How Many Sessions Are Needed?</h3>
              <p>
                Laser hair removal typically requires <span style={{ fontWeight: 'bold' }}>4 to 6</span> sessions or more depending on hair thickness,
                skin type, and treatment area. Each session gradually reduces hair growth and improves skin smoothness.
              </p>
              <p>Maintenance sessions may be recommended to maintain long-term results.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Who is Suitable for Laser Hair Removal?</h3>
              <p>Laser hair removal is suitable for individuals who:</p>
              <ul>
                <li>Experience frequent hair growth</li>
                <li>Want a long-term hair reduction solution</li>
                <li>Suffer from ingrown hair or razor bumps</li>
                <li>Want smoother skin without regular waxing or shaving</li>
              </ul>
              <p>The treatment works best when customized according to the patient&apos;s skin tone and hair type.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Why Choose a Professional Clinic for Laser Hair Removal?</h3>
              <p>Selecting a professional clinic for laser hair removal ensures:</p>
              <ul>
                <li>Safe and advanced laser technology</li>
                <li>Experienced cosmetic specialists</li>
                <li>Personalized treatment plans</li>
                <li>Hygienic clinical environment</li>
                <li>Better long-term results with minimal risk</li>
              </ul>
              <p>
                Expert supervision also reduces the chances of skin irritation, pigmentation changes, or burns that may occur if the procedure is
                performed incorrectly.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Get the Best Laser Hair Removal in Pitampura</h3>
              <p>
                If you want a relaible and long term solution for unwanted hair, choosing the{' '}
                <span style={{ fontWeight: 'bold' }}>best laser hair removal in Pitampura</span> can help you achieve smooth, hair-free skin with
                advanced technology and expert care.
              </p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Sweta Mishra'
              specialty='Maxillofacial Aesthetic Surgeon'
              education='MDS, FAM, Dip. in Aesthetic Medicine'
              image={doc_img}
              blurb='Dr. Sweta Mishra oversees laser hair reduction treatments at Sharva Clinique using advanced technology suited to different skin and hair types.'
              profileLink='/drSweta/laser'
            />

            <ServiceFAQ title='FAQs - Laser Hair Reduction' faqs={laserFAQs} />
          </div>

          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>

            <div className='card1'>
              <p>
                "I was nervous at first, but the team explained everything clearly and made me feel at ease. Very happy with the progress so far."
              </p>
              <p> — Rohan </p>
            </div>

            <div className='card2'>
              <p>"Professional, clean, and effective. The results are better than any other hair removal method I’ve tried. Worth every session."</p>
              <p> — Meera </p>
            </div>

            <div className='card3'>
              <p>
                "Friendly staff and professional care from start to finish. My skin feels smoother than ever, and the hair reduction is noticeable
                after just a few sessions."
              </p>
              <p> — Sarah</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Laserhair
